import styled from "styled-components"
import { pulse } from "../../consts/animations"
import { FC } from "react"
import { MAIN_COLORS } from "../../consts/colors"

interface IProps {
    height?: number | string
    width?: number | string
    radius?:number | string
}

const Wrapper = styled.div<IProps>`
    width: ${props => props.width ? (typeof props.width === 'number' ? `${props.width}px` : props.width) : '100px'}; 
    height: ${props => props.height ? (typeof props.height === 'number' ? `${props.height}px` : props.height) : '100px'}; 
    border-radius: ${props => props.radius ? (typeof props.radius === 'number' ? `${props.radius}px` : props.radius) : '4px'}; 
    background: linear-gradient(180deg,
      ${MAIN_COLORS.purple_300} 0%,
      ${MAIN_COLORS.purple_400} 100%
    );
    background-size: 100% 200%;
    animation: ${pulse} 2s ease-in-out infinite;
    opacity: 0;
    animation-fill-mode: both;
`
const Skeleton:FC<IProps> = ({height,width,radius}) => {
  return (
    <Wrapper height={height}width={width} radius={radius}/>
  )
}

export default Skeleton